import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { endpoints } from '../../core/constants/endpoints';
import {
  ICommunicationPreferences,
  ICommunicationPreferencesRaw,
  ICommunicationPreferencesRequest,
  toCommunicationPreferences,
  toCommunicationPreferencesRequestRaw
} from '../interfaces/communication-preferences.interface';

@Injectable({ providedIn: 'root' })
export class PreferencesApi {
  private readonly baseUrl = `${environment.ceppemAiApi}/${endpoints.ceppemAi.preferences}`;

  constructor(private http: HttpClient) {}

  get(): Observable<ICommunicationPreferences> {
    return this.http
      .get<ICommunicationPreferencesRaw>(this.baseUrl)
      .pipe(map(toCommunicationPreferences));
  }

  update(
    request: ICommunicationPreferencesRequest
  ): Observable<ICommunicationPreferences> {
    return this.http
      .put<ICommunicationPreferencesRaw>(
        this.baseUrl,
        toCommunicationPreferencesRequestRaw(request)
      )
      .pipe(map(toCommunicationPreferences));
  }
}
